import axios from 'axios';

// FastAPI returns 422 `detail` as an array of error objects. Passing that array
// straight into a toast renders an object as a React child (error #31) and blanks
// the whole app, so flatten it to a sentence once here for every call site.
const fieldLabel = (loc = []) => {
  const name = [...loc].reverse().find((p) => typeof p === 'string' && p !== 'body');
  return name ? name.replace(/_/g, ' ') : 'Field';
};

export const detailToMessage = (detail) => {
  if (detail === null || detail === undefined) return null;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      if (typeof d === 'string') return d;
      const label = fieldLabel(d?.loc);
      const pretty = label.charAt(0).toUpperCase() + label.slice(1);
      const msg = d?.msg || 'is invalid';
      if (/valid datetime|valid date|too short/i.test(msg)) return `${pretty} is required`;
      if (/field required/i.test(msg)) return `${pretty} is required`;
      return `${pretty}: ${msg}`;
    });
    return [...new Set(parts)].join(' · ');
  }
  if (typeof detail === 'object') return detail.msg || detail.message || 'Request failed';
  return String(detail);
};

export const extractErrorMessage = (error, fallback = 'Request failed') =>
  detailToMessage(error?.response?.data?.detail) || fallback;

axios.interceptors.response.use(undefined, (error) => {
  const data = error?.response?.data;
  if (data && typeof data === 'object' && data.detail && typeof data.detail !== 'string') {
    data.detail = detailToMessage(data.detail);
  }
  return Promise.reject(error);
});
